import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function TabExplainer({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl border border-neutral-200 bg-neutral-50 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-neutral-600 hover:bg-neutral-100 transition-colors"
      >
        <span>What does this tab show?</span>
        {open ? <ChevronUp size={15} className="text-neutral-400" /> : <ChevronDown size={15} className="text-neutral-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 text-sm text-neutral-600 leading-relaxed space-y-2 border-t border-neutral-200">
          {children}
        </div>
      )}
    </div>
  );
}
